import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import {
	Loading
} from 'element-ui'
export default {
	install(Vue, options) {
		// id-导出pdf的div容器；title-导出文件标题
		Vue.prototype.htmlToPdf = (id, title) => {
			var loading = Loading.service({
				lock: true,
				text: 'PDF导出中，请稍等',
				background: 'rgba(0, 0, 0, 0.7)'
			})
			const opts = {
				scale: 2, // 缩放比例，提高生成图片清晰度
				useCORS: true, // 允许加载跨域的图片
				allowTaint: false, // 允许图片跨域，和 useCORS 二者不可共同使用
				tainttest: true, // 检测每张图片已经加载完成
				logging: true // 日志开关，发布的时候记得改成 false
			}
			var addobj=[]
			let cont=0
			let idarr=id.split(',')
			const PDF = new JsPDF('', 'pt', 'a4')
			idarr.forEach(item=>{
				var element = document.getElementById(`${item}`)
				 html2Canvas(element, opts)
					.then((canvas) => {
						const contentWidth = canvas.width
						const contentHeight = canvas.height
						// 一页pdf显示html页面生成的canvas高度;
						const pageHeight = (contentWidth / 592.28) * 841.89
						// 未生成pdf的html页面高度
						let leftHeight = contentHeight
						// 页面偏移
						let position = 0
						// a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
						const imgWidth = 595.28
						const imgHeight = (592.28 / contentWidth) * contentHeight
						const pageData = canvas.toDataURL('image/jpeg', 1.0)
						// a4纸纵向，一般默认使用；new JsPDF('landscape'); 横向页面
						
						// 当内容未超过pdf一页显示的范围，无需分页
							// addImage(pageData, 'JPEG', 左，上，宽度，高度)设置
						addobj[item]={
							pageData:pageData,
							imgWidth:imgWidth,
							imgHeight:imgHeight
						} 
						cont++
						if(cont==idarr.length){
							loading.close()
							addobj.forEach((gtem,index)=>{
								console.log(gtem)
								PDF.addImage(gtem.pageData, 'JPEG', 0, 0, gtem.imgWidth, gtem.imgHeight)
								if(index!=addobj.length-1){
									PDF.addPage()
								}
							})
							PDF.save(title + '.pdf')
						}
						
					})
					.catch((error) => {
						loading.close()
						console.log('打印失败', error)
					})
			})
			
				
			
		}
	}
}